<template>
  <div class="relative py-24 sm:py-32 min-h-fit">
    <UiContainer>
      <div
        class="mx-auto grid grid-cols-1 lg:grid-cols-2
        gap-x-8 gap-y-16 sm:gap-y-20 items-center"
      >
        <!-- Text Section -->
        <div class="lg:pt-4 lg:pr-8">
          <div class="lg:max-w-lg">
            <UiTitle
              size="5xl"
              type="h2"
              :code="t('home.benefits.tag')"
              align="left"
            >
              {{ t('home.benefits.title') }}
            </UiTitle>
            <UiParagraph
              class="mt-6"
              size="lg"
              type="p"
              align="left"
            >
              {{ t('home.benefits.description') }}
            </UiParagraph>
            <ul class="mt-6 max-w-xl space-y-4 text-base lg:max-w-none">
              <li
                v-for="feature in features()"
                :key="feature.name"
                class="flex items-start gap-x-4"
              >
                <component
                  :is="feature.icon"
                  class="h-6 w-6 mt-1 text-indigo-500 dark:text-indigo-400"
                  aria-hidden="true"
                />

                <UiParagraph
                  size="base"
                  align="left"
                  class="flex-1 text-gray-600 dark:text-gray-300"
                >
                  <span
                    class="font-semibold text-gray-900 dark:text-white
                  underline"
                  >{{ feature.name }}</span>:
                  {{ ' ' + feature.description }}
                </UiParagraph>
              </li>
            </ul>
          </div>
        </div>

        <!-- Image Section -->
        <div class="pt-0 sm:pt-16">
          <img
            src="@/assets/images/landing/bennefits/goblin-bennefits.webp"
            alt="Product screenshot"
            class="mx-auto rounded-xl shadow-xl ring-1 ring-gray-400/10 max-h-full"
          >
        </div>
      </div>
    </UiContainer>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import UiContainer from '@/components/ui/UiContainer.vue';
import UiTitle from '@/components/ui/UiTitle.vue';
import UiParagraph from '@/components/ui/UiParagraph.vue';
import { UserGroupIcon, CalendarIcon, DevicePhoneMobileIcon } from '@heroicons/vue/24/outline';

const { t } = useI18n();

// Computed
const features = (() => [
  {
    name: t('home.benefits.feature1.name'),
    description: t('home.benefits.feature1.description'),
    icon: UserGroupIcon,
  },
  {
    name: t('home.benefits.feature2.name'),
    description: t('home.benefits.feature2.description'),
    icon: CalendarIcon,
  },
  {
    name: t('home.benefits.feature3.name'),
    description: t('home.benefits.feature3.description'),
    icon: DevicePhoneMobileIcon,
  },
]);
</script>
